
<style lang="scss">
// .bgImg {
//   position: fixed;
//   bottom: 0;
//   width: 100%;
//   img {
//     width: 100%;
//   }
// }
.bgImg{
  background: url("../assets/images/bg.png") no-repeat;
  background-position: bottom left;
  background-size: 100%;
  height: 100%;
}
</style>
<template>
  <div class="m2_layout_container">
    <div class="m2_layout bgImg" v-if="this.$route.name=='main'||this.$route.name=='batch_main'">
      <m2Header></m2Header>
      <router-view></router-view>
      <!-- <div class="bgImg" v-if="this.$route.name=='main'"><img src="@md2_images/bg.png" alt=""></div> -->
      <m2-footer></m2-footer>
    </div>
    <div class="m2_layout" v-else>
      <m2Header></m2Header>
      <router-view></router-view>
      <!-- <div class="bgImg" v-if="this.$route.name=='main'"><img src="@md2_images/bg.png" alt=""></div> -->
      <m2-footer></m2-footer>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import m2Header from "@components/header/m2_header";
import m2Footer from "@components/footer/m2_footer.vue";
export default {
  components: {
    m2Header,
    m2Footer
  },
  data() {
    return {};
  }
};
</script>